// There are two versions of window.scrollTo:
// 1.    scrollTo(options?: { behavior?: "auto" | "smooth"; left?: number; top?: number; }): void;
// 2.    scrollTo(x: number, y: number): void;
// this utility deals with only the second one.
//
// SEE: https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollTo

import logger from 'utils/logger.util';
import isNotFn from 'utils/predicates/function/isNotFn.util';

const L = logger('windowScrollTo');

const windowScrollTo = (x, y) => {
  if (!window) {
    L.warn('There is no window:', window);
    return;
  }

  if (isNotFn(window.scrollTo)) {
    L.warn('There is function window.scrollTo:', window.scrollTo);
    return;
  }

  window.scrollTo(x, y);
};

// noinspection JSUnusedGlobalSymbols
export default windowScrollTo;
